<div class="p-6">
  <h1 class="text-2xl font-semibold mb-4">User Management</h1>

  <!-- Error Banner -->
  <div *ngIf="error" class="mb-4 p-3 rounded bg-red-100 text-red-700 border border-red-200">
    {{ error }}
  </div>

  <!-- Create/Update Form -->
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="grid gap-4 grid-cols-1 md:grid-cols-2 bg-white rounded-lg p-4 shadow">
    <div class="md:col-span-1">
      <label class="block text-sm font-medium mb-1">Username</label>
      <input type="text" formControlName="username" class="w-full border rounded px-3 py-2" placeholder="j.doe" />
    </div>

    <div class="md:col-span-1">
      <label class="block text-sm font-medium mb-1">Email</label>
      <input type="email" formControlName="email" class="w-full border rounded px-3 py-2" placeholder="john@acme.com" />
    </div>

    <div class="md:col-span-1">
      <label class="block text-sm font-medium mb-1">Password</label>
      <input type="password" formControlName="password" class="w-full border rounded px-3 py-2" placeholder="••••••••" />
      <p class="text-xs text-gray-500 mt-1" *ngIf="isEditMode">Leave empty to keep existing password</p>
    </div>

    <div class="md:col-span-1">
      <label class="block text-sm font-medium mb-1">Roles</label>
      <input type="text" formControlName="roles" class="w-full border rounded px-3 py-2" placeholder="e.g. USER, ADMIN" />
      <p class="text-xs text-gray-500 mt-1">Comma-separated</p>
    </div>

    <div class="md:col-span-2 flex items-center gap-2">
      <button type="submit" [disabled]="form.invalid" class="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700">
        {{ isEditMode ? 'Update User' : 'Create User' }}
      </button>
      <button type="button" *ngIf="isEditMode" (click)="cancelEdit()" class="px-4 py-2 rounded border">Cancel</button>
    </div>
  </form>

  <!-- Users Table -->
  <div class="mt-8 bg-white rounded-lg shadow overflow-x-auto">
    <table class="min-w-full">
      <thead class="bg-gray-50">
        <tr>
          <th class="text-left px-4 py-2">ID</th>
          <th class="text-left px-4 py-2">Username</th>
          <th class="text-left px-4 py-2">Email</th>
          <th class="text-left px-4 py-2">Roles</th>
          <th class="text-right px-4 py-2">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading">
          <td colspan="5" class="px-4 py-3">Loading...</td>
        </tr>
        <tr *ngFor="let u of users" class="border-t">
          <td class="px-4 py-2">{{ u.id }}</td>
          <td class="px-4 py-2">{{ u.username }}</td>
          <td class="px-4 py-2">{{ u.email }}</td>
          <td class="px-4 py-2">{{ u.roles?.join(', ') }}</td>
          <td class="px-4 py-2">
            <div class="flex gap-2 justify-end">
              <button class="px-3 py-1 text-sm rounded border" (click)="edit(u)">Edit</button>
              <button class="px-3 py-1 text-sm rounded bg-red-600 text-white" (click)="confirmDelete(u)">Delete</button>
            </div>
          </td>
        </tr>
        <tr *ngIf="!loading && users.length === 0">
          <td colspan="5" class="px-4 py-3 text-gray-500">No users found.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
